import { getOktaAccessToken } from "../LocalStorage";
import { request } from "./Api";
import GetAllDeliveryPartnersResponse from "../../interfaces/GetAllDeliveryPartnersResponse";
import DeliveryPartner from "../../interfaces/DeliveryPartner";
import DeliveryPartnerBusinessUnitOverride from "../../interfaces/DeliveryPartnerBusinessUnitOverride";
import GetAllBusinessUnitOverridesResponse from "../../interfaces/GetAllBusinessUnitOverridesResponse";
import updateDeliveryPartnersResponse from "../../interfaces/UpdateDeliveryPartnersResponse";
import UpdateDeliveryPartnersResponse from "../../interfaces/UpdateDeliveryPartnersResponse";
import BusinessUnit from "../../interfaces/BusinessUnit";
import businessUnitOverrides from "../../components/DeliveryPartners/BusinessUnitOverrides/BusinessUnitOverrides";

const DELIVERY_PARTNERS_API_BASE_URL =
  process.env.REACT_APP_DELIVERY_PARTNERS_API_BASE_URL;
const FCR_BUSINESS_UNITS_API_BASE_URL =
  process.env.REACT_APP_BUSINESS_UNITS_API_BASE_URL;

const getAllDeliveryPartners = (): Promise<DeliveryPartner[]> => {
  const token = getOktaAccessToken();
  if (!token) {
    return Promise.reject("Missing Token");
  }

  return request({
    method: "GET",
    url: DELIVERY_PARTNERS_API_BASE_URL + "/delivery-partners",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response: GetAllDeliveryPartnersResponse) => {
      return response.deliveryPartners;
    })
    .catch((error: string) => {
      error = "Could not retrieve delivery partners";
      throw error;
    });
};

const getBusinessUnitOverridesByDeliveryPartner = (
  deliveryPartnerId: any
): Promise<DeliveryPartnerBusinessUnitOverride[]> => {
  const token = getOktaAccessToken();
  if (!token) {
    return Promise.reject("Missing Token");
  }
  return request({
    method: "GET",
    url:
      DELIVERY_PARTNERS_API_BASE_URL +
      `/delivery-partners/${deliveryPartnerId}/overrides`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response: GetAllBusinessUnitOverridesResponse) => {
      return response.deliveryPartnerBusinessUnitOverrides;
    })
    .catch((error: string) => {
      throw error;
    });
};

const updateDeliveryPartner = (
  deliveryPartners: any
): Promise<UpdateDeliveryPartnersResponse | void> => {
  const token = getOktaAccessToken();
  if (!token) {
    return Promise.reject("Missing Token");
  }
  return request({
    method: "PUT",
    url: DELIVERY_PARTNERS_API_BASE_URL + `/delivery-partners`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: { deliveryPartners },
  })
    .then((response: updateDeliveryPartnersResponse) => {
      return response;
    })
    .catch((error: string) => {
      throw error;
    });
};

const updateDeliveryPartnerCommission = (
  commission: any
): Promise<UpdateDeliveryPartnersResponse | void> => {
  const token = getOktaAccessToken();
  if (!token) {
    return Promise.reject("Missing Token");
  }
  return request({
    method: "PUT",
    url: DELIVERY_PARTNERS_API_BASE_URL + `/commission-rate-history`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: commission,
  })
    .then((response: updateDeliveryPartnersResponse) => {
      return response;
    })
    .catch((error: string) => {
      throw error;
    });
};

const deleteDeliveryPartnerCommission = (
  commissionId: any
): Promise<UpdateDeliveryPartnersResponse | void> => {
  const token = getOktaAccessToken();
  if (!token) {
    return Promise.reject("Missing Token");
  }
  return request({
    method: "DELETE",
    url:
      DELIVERY_PARTNERS_API_BASE_URL +
      `/commission-rate-history/` +
      commissionId,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response: updateDeliveryPartnersResponse) => {
      return response;
    })
    .catch((error: string) => {
      throw error;
    });
};

const updateDeliveryPartnerOverrides = (
  overrides: any
): Promise<UpdateDeliveryPartnersResponse | void> => {
  const token = getOktaAccessToken();
  if (!token) {
    return Promise.reject("Missing Token");
  }
  return request({
    method: "PUT",
    url: DELIVERY_PARTNERS_API_BASE_URL + `/overrides`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: { deliveryPartnerBusinessUnitOverrides: overrides },
  })
    .then((response: updateDeliveryPartnersResponse) => {
      return response;
    })
    .catch((error: string) => {
      throw error;
    });
};

const deleteDeliveryPartnerOverride = (
  overrideId: any
): Promise<UpdateDeliveryPartnersResponse | void> => {
  const token = getOktaAccessToken();
  if (!token) {
    return Promise.reject("Missing Token");
  }
  return request({
    method: "DELETE",
    url: DELIVERY_PARTNERS_API_BASE_URL + `/overrides/` + overrideId,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response: updateDeliveryPartnersResponse) => {
      return response;
    })
    .catch((error: string) => {
      throw error;
    });
};

const getAllBusinessUnits = (): Promise<BusinessUnit[]> => {
  const token = getOktaAccessToken();

  if (!token) {
    return Promise.reject("Missing Token");
  }

  return request({
    method: "GET",
    url: FCR_BUSINESS_UNITS_API_BASE_URL + "/business-units",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return response.businessUnits;
    })
    .catch((error: string) => {
      error = "Could not retrieve locations";
      throw error;
    });
};

export {
  getAllDeliveryPartners,
  getBusinessUnitOverridesByDeliveryPartner,
  getAllBusinessUnits,
  updateDeliveryPartner,
  updateDeliveryPartnerCommission,
  deleteDeliveryPartnerCommission,
  updateDeliveryPartnerOverrides,
  deleteDeliveryPartnerOverride,
};
